import { Drawer, styled } from "@mui/material";

export const InlineDrawer = styled(Drawer)`
  position: relative;

  & > .MuiPaper-root {
    position: absolute;
  }
`;
